import { createContext, useContext, useState } from "react";

const AiContext = createContext(null);

export function AiProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [seed, setSeed] = useState("");
  const openWith = (text = "") => { setSeed(text); setOpen(true); };
  return <AiContext.Provider value={{ open, setOpen, seed, setSeed, openWith }}>{children}</AiContext.Provider>;
}

export const useAi = () => useContext(AiContext);
